import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchAdminUsers } from '../services/admin-users';

const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString();
};

function UsersTable() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await fetchAdminUsers();
      setUsers(data);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load users.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>User Management</h1>
        <p>Manage admin users</p>
      </div>

      <div className="section-card">
        <div className="header-actions">
          <h2>Users ({users.length})</h2>
          <div className="btn-group">
            <button type="button" className="btn btn-secondary" onClick={loadUsers}>
              Refresh
            </button>
            <Link to="/users/create" className="btn btn-primary link-btn">
              Create User
            </Link>
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}

        {users.length === 0 ? (
          <p style={{ color: '#999' }}>No users found.</p>
        ) : (
          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.email}</td>
                    <td>
                      <span className={`badge ${user.status === 1 ? 'success' : 'danger'}`}>
                        {user.status === 1 ? 'active' : 'inactive'}
                      </span>
                    </td>
                    <td>{formatDate(user.created_at)}</td>
                    <td>{formatDate(user.updated_at)}</td>
                    <td>
                      <Link to={`/users/${user.id}/edit`} className="btn btn-primary btn-sm link-btn">
                        Edit
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default UsersTable;
